import { CommercialCondModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/commercial-condition-mode.enum";

/**
 * Option order of the Commercial Conditions select on the Route form.
 *
 * COMPANY_CONFIG ("Segun configuracion de compania") hands the decision to the
 * company's own mode, so it reads last, after every explicit mode. A value added
 * to CommercialCondModeEnum still shows up without touching this list.
 */
export const SUB_ROUTE_COMMERCIAL_CONDITION_MODES: readonly CommercialCondModeEnum[] =
  [
    ...Object.values(CommercialCondModeEnum).filter(
      (mode) => mode !== CommercialCondModeEnum.COMPANY_CONFIG
    ),
    CommercialCondModeEnum.COMPANY_CONFIG,
  ];
